<div *ngIf="!loading" class="recent-serving-counters --{{ count }}" (click)="refresh()">
  <div class="recent-serving-title">{{ 'currentlyServing' | translate }}</div>

  <div class="counter-column">
    <div *ngFor="let token of recentServingTokens; let i = index" class="token-number">
      <app-svg-text heightCropFactor="0.9" [text]="token?.tokenNumber" customClass="token-number-text"></app-svg-text>
    </div>
  </div>
  <div class="counter-column">
    <div *ngFor="let token of recentServingTokens; let i = index" class="counter-name">
      <app-svg-text [text]="token?.counterName" customClass="counter-name-text"></app-svg-text>
    </div>
  </div>
</div>
<app-loader *ngIf="loading"></app-loader>
